import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { MerchantScaleConfigurationCard } from './components/merchantscale-configuration-card'
import { MerchantScaleDescriptorCard } from './components/merchantscale-descriptor-card'
import { MerchantScaleFeaturesCard } from './components/merchantscale-features-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface MerchantScaleProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const MerchantScaleProcessorDetailsPage = ({ processor }: MerchantScaleProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="merchantscale"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <MerchantScaleConfigurationCard processor={processor} />
            <MerchantScaleDescriptorCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <MerchantScaleFeaturesCard />
        </>
    )
}
